export default __webpack_public_path__ + "static/media/roadmap-d-1.1d791573.png";